import React from "react";

import styles from "./spinner.module.scss";

const spinner = () => {
  return <div className={styles.Loader}>Loading...</div>;
};

export default spinner;
